module.exports = __webpack_public_path__ + "static/media/rewards-bg.bd82fd7e.png";